import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.show,
    persistent: "",
    "max-width": "760"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        color: "surface",
        rounded: "lg",
        class: "pa-6"
      }, {
        default: _withCtx(() => [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-center mb-6" }, [
            _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-2" }, "Welcome to MissionSquad"),
            _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-0" }, " How would you like to get started? You can switch anytime later. ")
          ], -1)),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "background",
                    variant: "elevated",
                    elevation: "4",
                    height: "100%",
                    class: "pa-5 d-flex flex-column ga-3 mode-card",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.choose('simple')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        color: "primary",
                        variant: "tonal",
                        rounded: "lg",
                        size: "46"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { icon: "mdi-rocket-launch-outline" })
                        ]),
                        _: 1
                      }),
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "I’m just getting started", -1)),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis flex-grow-1" }, " A simpler workspace — chat, automations, and the essentials. No workflow graphs or config to learn. ", -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-caption text-disabled text-uppercase" }, "Non-technical", -1))
                    ]),
                    _: 1,
                    __: [2,3,4]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    color: "background",
                    variant: "elevated",
                    elevation: "4",
                    height: "100%",
                    class: "pa-5 d-flex flex-column ga-3 mode-card",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.choose('advanced')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        color: "primary",
                        variant: "tonal",
                        rounded: "lg",
                        size: "46"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { icon: "mdi-tune-variant" })
                        ]),
                        _: 1
                      }),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "I’m a technical user", -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-body-2 text-medium-emphasis flex-grow-1" }, " Full access — workflows, factories, schedules, embeddings and every advanced control. ", -1)),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-caption text-disabled text-uppercase" }, "Technical", -1))
                    ]),
                    _: 1,
                    __: [5,6,7]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1,
        __: [8]
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}